/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VersionResponse } from '../../models/version-response';

export interface GetHome$Params {
}

export function getHome(http: HttpClient, rootUrl: string, params?: GetHome$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionResponse>> {
  const rb = new RequestBuilder(rootUrl, getHome.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VersionResponse>;
    })
  );
}

getHome.PATH = '/';
